import { render, staticRenderFns } from "./page-main.vue?vue&type=template&id=1dbef90b&scoped=true"
import script from "./page-main.vue?vue&type=script&lang=js"
export * from "./page-main.vue?vue&type=script&lang=js"
import style0 from "./page-main.styl?vue&type=style&index=0&id=1dbef90b&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbef90b",
  null
  
)

export default component.exports